import styles from "../CreatorsPage.module.scss";
import { SMark } from "./icons";
import { img } from "./images";

const ROUTE = "M52.5 175.6 Q96.1 250.7 172.4 292.2 Q166.7 322.7 146.0 345.9 Q252.8 353.6 348.1 304.7 Q388.9 183.5 486.7 101.2 Q540.9 101.8 587.5 74.1";
// Where the route's stops sit, as % of the map.
const STOPS: [left: string, top: string][] = [
	["8.2%", "41.8%"],
	["26.9%", "69.6%"],
	["22.8%", "82.4%"],
	["54.4%", "72.5%"],
	["76.0%", "24.1%"],
	["91.8%", "17.6%"],
];

/** Ilse's "Mexico in 3 weeks" route on a map, as the embed on a blog and as the trip card show it. */
const MexicoMap = ({ strokeWidth }: { strokeWidth: number }) => (
	<div className={styles.smap}>
		<img src={img("embed-mexico.webp")} alt="" />
		<svg viewBox="0 0 640 420" preserveAspectRatio="none">
			<path d={ROUTE} fill="none" stroke="#EA5681" strokeWidth={strokeWidth} strokeLinecap="round" vectorEffect="non-scaling-stroke" />
		</svg>
		{STOPS.map(([left, top]) => (
			<span key={left} className={styles.hdot2} style={{ left, top }}></span>
		))}
		<span className={styles.slogo}>
			<SMark />
			<span className={styles.wordmark}>stippl</span>
		</span>
	</div>
);

export default MexicoMap;
